$(document).on("ready", function () {
  /* Faqs */
  let question = document.querySelectorAll(".question");
    question.forEach(question => {
      question.addEventListener("click", event => {
        const active = document.querySelector(".question.active");
        if(active && active !== question ) {
          active.classList.toggle("active");
          active.nextElementSibling.style.maxHeight = 0;
        }
        question.classList.toggle("active");
        const answer = question.nextElementSibling;
        if(question.classList.contains("active")){
          answer.style.maxHeight = answer.scrollHeight + "px";
        } else {
          answer.style.maxHeight = 0;
        }
      })
    })

  let myContainer = document.querySelectorAll(".myContainer");
  
  myContainer.forEach(myContainer => {
      myContainer.addEventListener("click", event => {
      const active = document.querySelector(".myContainer.active");
      if(active && active !== myContainer ) {
          active.classList.toggle("active");
      }
      myContainer.classList.toggle("active");
      const answer = myContainer.nextElementSibling;
      if(myContainer.classList.contains("active")){
      } else {
      }
      })
  })
  /* End Here */
$(".recentSlider").slick({
      dots: true,
      padding:0,
      infinite: true,
      centerMode: true,
      slidesToShow: 4,
      arrows:false,
      autoplay:false,
      autoplaySpeed:2500,
      nextArrow: '<span class="next arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      prevArrow: '<span class="prev arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            arrows:false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            dots:false,
            autoplay:true,
            arrows:false
          }
        },
         {
          breakpoint: 567,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        }
      ]
    }); 
  
  
});
// add price to add to cart button
document.addEventListener('DOMContentLoaded', () => {

  function updateButtonPrice(productInfo) {
    if (!productInfo) return;

    const btnPrice = productInfo.querySelector('.btn-price');
    const qtyInput = productInfo.querySelector('.quantity__input');

    if (!btnPrice || !qtyInput) return;

    // Get current displayed price (sale price if available)
    const priceElement =
      productInfo.querySelector('.price-item--sale') ||
      productInfo.querySelector('.price-item--regular');

    if (!priceElement) return;

    const qty = parseInt(qtyInput.value || 1, 10);

    // Extract numeric value
    const amount = parseFloat(
      priceElement.textContent.replace(/[^0-9.]/g, '')
    );

    if (isNaN(amount)) return;

    const formatter = new Intl.NumberFormat(
      Shopify.locale || 'en-US',
      {
        style: 'currency',
        currency: Shopify.currency.active
      }
    );

    btnPrice.textContent = ` - ${formatter.format(amount * qty)}`;
  }

  document.querySelectorAll('product-info').forEach((productInfo) => {

    updateButtonPrice(productInfo);

    // Quantity
    const qty = productInfo.querySelector('.quantity__input');

    qty?.addEventListener('input', () => updateButtonPrice(productInfo));
    qty?.addEventListener('change', () => updateButtonPrice(productInfo));

    // + / - buttons
    productInfo.querySelectorAll('.quantity__button').forEach(btn => {
      btn.addEventListener('click', () => {
        setTimeout(() => updateButtonPrice(productInfo), 10);
      });
    });

    // Variant changes
    const observer = new MutationObserver(() => {
      updateButtonPrice(productInfo);
    });

    observer.observe(
      productInfo.querySelector('[id^="price-"]'),
      {
        childList: true,
        subtree: true
      }
    );
  });

});

// WishList Start
// INIT
function getWishlist() {
  return JSON.parse(localStorage.getItem('wishlist')) || [];
}

function saveWishlist(wishlist) {
  localStorage.setItem('wishlist', JSON.stringify(wishlist));
  updateWishlistCount();
}

// ADD / REMOVE
function toggleWishlist(handle) {
  let wishlist = getWishlist();

  if (wishlist.includes(handle)) {
    wishlist = wishlist.filter(item => item !== handle);
  } else {
    wishlist.push(handle);
  }

  saveWishlist(wishlist);
  updateButtons();
}

// BUTTON CLICK
document.addEventListener('click', function(e) {
  if (e.target.closest('.wishlist-btn')) {
    let btn = e.target.closest('.wishlist-btn');
    let handle = btn.getAttribute('data-product-handle');
    toggleWishlist(handle);
  }
});

// UPDATE BUTTON UI
function updateButtons() {
  let wishlist = getWishlist();

  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    let handle = btn.getAttribute('data-product-handle');
    let path = btn.querySelector('svg path');

    if (!path) return;

    if (wishlist.includes(handle)) {
      // ❤️ FILLED
      path.setAttribute('fill', 'red');
      path.setAttribute('stroke', 'red');
      btn.classList.add('active');
    } else {
      // ♡ OUTLINE
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', '#fff');
      btn.classList.remove('active');
    }
  });
}

// HEADER COUNT
function updateWishlistCount() {
  let count = getWishlist().length;
  let el = document.querySelector('.wishlist-count');
  if (el) el.innerText = count;
}

// INIT LOAD
document.addEventListener('DOMContentLoaded', function() {
  updateButtons();
  updateWishlistCount();
});

// Wishlist Ends
